import { useEffect } from 'react';
import api from '../lib/api';

// Simple module-level cache so we don't re-fetch the same SEO doc on every navigation
const CACHE = {};

// Split into small helpers so the effect body stays focused and the linter is satisfied
function upsertMeta(name, content, attr = 'name') {
    if (!content) return;
    let m = document.querySelector(`meta[${attr}="${name}"]`);
    if (!m) {
        m = document.createElement('meta');
        m.setAttribute(attr, name);
        document.head.appendChild(m);
    }
    m.setAttribute('content', content);
}

function upsertCanonical(path) {
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
        canonical = document.createElement('link');
        canonical.setAttribute('rel', 'canonical');
        document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', `${window.location.origin}${path}`);
}

function applySeo(data, path) {
    if (data?.title) document.title = data.title;
    if (data?.description) upsertMeta('description', data.description);
    if (data?.keywords) upsertMeta('keywords', data.keywords);
    if (data?.robots) upsertMeta('robots', data.robots);
    if (data?.title) {
        upsertMeta('og:title', data.title, 'property');
        upsertMeta('twitter:title', data.title);
    }
    if (data?.description) {
        upsertMeta('og:description', data.description, 'property');
        upsertMeta('twitter:description', data.description);
    }
    if (data?.og_image) {
        upsertMeta('og:image', data.og_image, 'property');
        upsertMeta('twitter:image', data.og_image);
    }
    upsertCanonical(path);
}

export default function useSeo(pathOverride) {
    const path = pathOverride || (typeof window !== 'undefined' ? window.location.pathname : '/');
    useEffect(() => {
        let cancelled = false;
        if (CACHE[path]) {
            applySeo(CACHE[path], path);
            return () => { cancelled = true; };
        }
        api.get('/seo/by-path', { params: { path } })
            .then((r) => {
                if (cancelled) return;
                CACHE[path] = r.data;
                applySeo(r.data, path);
            })
            .catch((err) => {
                if (process.env.NODE_ENV !== 'production') console.debug('[useSeo] SEO fetch failed:', err);
            });
        return () => { cancelled = true; };
    }, [path]);
}
